// extracted by mini-css-extract-plugin
export default {"icon":"VerifyEmail_icon__gPzyY","title":"VerifyEmail_title__nGP5W","text":"VerifyEmail_text__frlmG","resend":"VerifyEmail_resend__t-Dl9","button":"VerifyEmail_button__acrUP"};